/* eslint-disable react/button-has-type */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Button from '../../Components/Button';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import NavBarVertical from '../../Components/NavBarVertical';
import Accordion from '../../Components/AccordionLight';
import NavBarMobile from '../../Components/NavBarMobile';

class Practice extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        {/* image={require('./laptop-image.png')} */}
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="practice-format-content">
                <h1>Practice Materials</h1>
                <h3>Linguaskill preparation</h3>
                <p>
                  We have a range of resources to help candidates who are preparing for a
                  Linguaskill test.
                </p>
                <div className="accordion-practice">
                  <Accordion>
                    <div label="Candidates with disabilities or special requirements">
                      <h3>Candidates with disabilities or special requirements</h3>
                      <p>
                        We have a number of ways to help people taking our tests who need special
                        arrangements due to temporary or long term difficulties or conditions.
                      </p>
                      <Button as="link" color="red" basic onClick={() => '#employeeBenefits'}>
                        Click here for information
                      </Button>
                    </div>
                    <div label="Free online practice tests">
                      <h3>Free online practice tests</h3>
                      <p>
                        Our practice tests help you get comfortable with the format and layout of
                        the test while also providing you with feedback on the responses you have
                        entered. You can take these practice tests as many times as you like.
                      </p>
                      <p>
                        Linguaskill is an adaptive test that changes the questions based on your
                        answers, to provide you with a score. Our practice tests are not adaptive –
                        there are three tests available, at elementary, intermediate, and advanced
                        levels.
                      </p>
                      <h3>Linguaskill General practice tests</h3>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/a1-a2-practice-questions/story.html'
                        }
                      >
                        Linguaskill General Reading and Listening Elementary
                      </Button>

                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/b1-b2-practice-questions/story.html'
                        }
                      >
                        Linguaskill General Reading and Listening Intermediate
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/b1-b2-practice-questions/story.html'
                        }
                      >
                        Linguaskill General Reading and Listening Advanced
                      </Button>
                      <h3>Linguaskill Business practice tests</h3>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/practice-tests-2018/A+level+Test+-+Reading+and+Listening/story_html5.html'
                        }
                      >
                        Linguaskill Business Reading and Listening Elementary
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/practice-tests-2018/B+level+Test+-+Reading+and+Listening/story_html5.html'
                        }
                      >
                        Linguaskill Business Reading and Listening Intermediate
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://s3-eu-west-1.amazonaws.com/prd-swp-le/linguaskill/practice-tests-2018/C+level+Test+-+Reading+and+Listening+V2/story_html5.html'
                        }
                      >
                        Linguaskill Business Reading and Listening Advanced
                      </Button>
                    </div>
                    <div label="Free online sample tests">
                      <h3>Free online sample tests</h3>
                      <p>
                        Use these online sample tests to familiarise yourself with the types of
                        questions used on Linguaskill. These sample tests do not provide a result or
                        save your answers.
                      </p>
                      <p>
                        Note: The Reading and Listening sample test is not adaptive and is shorter
                        than a real test. The Speaking sample test requires a headphone set and
                        microphone.
                      </p>
                      <h2>Linguaskill General sample tests</h2>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LSKLDEMO02'
                        }
                      >
                        Take the Linguaskill General Reading and Listening sample test
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=WritingDemoLinguaskill'
                        }
                      >
                        Take the Linguaskill General Writing sample test
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=SPEAKINGDEMO'
                        }
                      >
                        Take the Linguaskill General Speaking sample test
                      </Button>
                      <h2>Linguaskill Business sample tests</h2>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LinguaskillBusinessDemo'
                        }
                      >
                        Take the Linguaskill Business Reading and Listening sample test
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=WritingDemoLinguaskillBusiness'
                        }
                      >
                        Take the Linguaskill Business Writing sample test
                      </Button>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.metritests.com/metricatestdelivery/Assessment/Assignment?test=LinguaskillBusinessSpeakingSampleTest'
                        }
                      >
                        Take the Linguaskill Business Speaking sample test
                      </Button>
                    </div>
                    <div label="Special Requirements sample materials">
                      <h3>Special Requirements sample materials</h3>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.cambridgeenglish.org/help/special-requirements/#modified'
                        }
                      >
                        All Special Requirements Sample Material for Linguaskill
                      </Button>
                    </div>
                    <div label="Online vocabulary builder">
                      <h3>Online vocabulary builder</h3>
                      <p>
                        Prepare for your test by improving your business English with our
                        personalised online learning materials. They adapt to your rates of
                        learning, and remind and quiz you to build your English vocabulary.
                      </p>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'https://www.cambridgeenglish.org/cmp/online-vocabulary-builder/index.aspx'
                        }
                      >
                        Find out more about the online vocabulary builder
                      </Button>
                    </div>
                    <div label="Free English practice">
                      <h3>Free English practice</h3>
                      <p>
                        We have produced a range of free online activities for reading, writing,
                        pronunciation, listening and grammar aligned to the
                        <a href="https://www.cambridgeenglish.org/exams-and-tests/cefr/index.aspx">
                          CEFR
                        </a>
                        levels tested in Linguaskill. You can choose the skill you want to practise
                        and the level that is right for you.
                      </p>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() => 'http://www.cambridgeenglish.org/learning-english'}
                      >
                        Search for free English activities
                      </Button>
                    </div>
                    <div label="Free games and social media">
                      <h3>Free games and social media</h3>
                      <p>
                        Playing games, watching videos and talking to other people are all great
                        ways of improving your English.
                      </p>
                      <Button
                        as="link"
                        color="red"
                        basic
                        onClick={() =>
                          'http://www.cambridgeenglish.org/learning-english/games-social/'
                        }
                      >
                        Download games to your phone, play online and join our Facebook community
                      </Button>
                    </div>
                    <div label="Official Cambridge English preparation materials">
                      <h3>Official Cambridge English preparation materials</h3>
                      <p>
                        Cambridge English Empower is a general course that covers all levels of the
                        <a href="https://www.cambridgeenglish.org/exams-and-tests/cefr/index.aspx">
                          CEFR
                        </a>
                        . You can choose a course to suit your needs, from A1-C1.
                      </p>
                      <div className="download">
                        <a href="http://www.cambridge.org/gb/cambridgeenglish/catalog/adult-courses/cambridge-english-empower">
                          <img alt="Cambridge" src={require('./Empower.jpg')} />
                          <div className="style-download">
                            <div className="__content">
                              <h3>Cambridge English Empower</h3>
                            </div>
                            <div className="__footer">
                              <button className="download-button">Buy book</button>
                            </div>
                          </div>
                        </a>
                      </div>
                      <p>
                        * The Speaking module is currently available in Spain and other selected
                        countries only; please contact your Cambridge English representative for
                        more information.
                      </p>
                    </div>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default Practice;
